import { NavLink } from 'react-router-dom';
import { Home, Users, MessageCircle, User, Menu, LayoutDashboard } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';
import { openMobileSidebar } from './MobileSidebar';

export const BottomNav = () => {
  const { user } = useAuth();

  const navItems = [
    { to: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { to: '/', icon: Home, label: 'Explore' },
    { to: '/discover', icon: Users, label: 'Connections' },
    { to: '/messages', icon: MessageCircle, label: 'Messages' },
    { to: `/profile/${user?.username}`, icon: User, label: 'Profile' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 border-t border-stone-200 dark:border-zinc-800 bg-white/95 dark:bg-zinc-900/95 backdrop-blur-xl z-50 lg:hidden safe-area-bottom">
      <div className="flex justify-around items-center h-16 max-w-lg mx-auto">
        {/* Menu button for sidebar */}
        <button
          onClick={openMobileSidebar}
          className="flex flex-col items-center justify-center p-2 rounded-xl transition-all duration-200 text-stone-500 dark:text-zinc-400 hover:text-stone-700 dark:hover:text-zinc-200"
          data-testid="mobile-nav-menu"
        >
          <Menu className="w-6 h-6" strokeWidth={1.5} />
          <span className="text-[10px] mt-0.5">Menu</span>
        </button>

        {navItems.slice(0, 4).map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={`mobile-nav-${label.toLowerCase()}`}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center justify-center p-2 rounded-xl transition-all duration-200',
                isActive 
                  ? 'text-gathrr-500 dark:text-gathrr-400' 
                  : 'text-stone-500 dark:text-zinc-400 hover:text-stone-700 dark:hover:text-zinc-200'
              )
            }
          >
            <Icon className="w-6 h-6" strokeWidth={1.5} />
            <span className="text-[10px] mt-0.5">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
